// extracted by mini-css-extract-plugin
module.exports = {"host":"CharityStatsToolbar_host__1uoUZ","leftSide":"CharityStatsToolbar_leftSide__28gQR","label":"CharityStatsToolbar_label__1aM9L","button":"CharityStatsToolbar_button__kuN55"};